import { render, staticRenderFns } from "./TransportInformation.vue?vue&type=template&id=152e3fc8&scoped=true"
import script from "./TransportInformation.vue?vue&type=script&lang=js"
export * from "./TransportInformation.vue?vue&type=script&lang=js"
import style0 from "./TransportInformation.vue?vue&type=style&index=0&id=152e3fc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152e3fc8",
  null
  
)

export default component.exports